import iconLogo from '../assets/logo.png';
import iconLogo2 from '../assets/logo2.png';

export const use_theme_dark = false;

export const logo = iconLogo; // || 'https://www.seguranca.go.gov.br/wp-content/uploads/2014/03/ssp-logo-sem-justica.png';
export const logo2 = iconLogo2; // || 'https://www.seguranca.go.gov.br/wp-content/uploads/2014/03/ssp-logo-sem-justica.png';

export const nameProject = 'Sistema HPM';

export const sistemaNameSSO = 'csmpm';

export const domainNameProd = 'csmpm.ssp.go.gov.br';
export const domainNameHomo = 'csmpm-homo.ssp.go.gov.br';
export const domainNameDesv = 'localhost';

export const perfisSistema = {};
perfisSistema.ADM = 'ADM'; //adm so irá ver modulo de configurações,
//legadosws se retornar algum erro peço para atualizar a pagina novamente!
//profissionais de saude: PERFIL_PSICOLOGO, GERENTE_PSICOLOGO
perfisSistema.PERFIL_PSICOLOGO = 'PERFIL PSICOLOGO'; //profissional de saúde, colocar uma dialog para pedir o cadastramento,
perfisSistema.GERENTE_PSICOLOGO = 'GERENTE PSICOLOGO'; //gerente
perfisSistema.PERFIL_SECRETARIA = 'PERFIL SECRETARIA'; //recepcionista, atendente
perfisSistema.ALL = 'QUALQUER_PERFIL';
perfisSistema.CSI = 'CSI'; //Por enquanto o perfil padrão vai ser esse do CSI

export const moduloSistema = {};
moduloSistema.CSI = 'CSI';
moduloSistema.PSICOLOGIA = 'PSICOLOGIA';
moduloSistema.CONFIGURACAO = 'CONFIGURACAO';
